import { polyfillCountryFlagEmojis } from "country-flag-emoji-polyfill";
import React, { useContext, useEffect, useRef, useState } from "react";
import cheveronDownIconWhite from "../../assets/cheveron-down-white.svg";
import cheveronDownIcon from "../../assets/cheveron-down.svg";
import { ScrollContext } from "../../contexts/ScrollContext";
import { getNewDeviceName } from "../../functions/utilities";
import { useKeyPress } from "../InputHooks";
import styles from "./DropDownInput.module.css";

const DropdownInput = ({
  labelName,
  listElements,
  isEnabled,
  value,
  placeholder,
  validationText,
  onSelection,
  display,
  inputStyle = {},
  loginBanner = false,
  languageSelection = false,
  isDevices = false,
  onClearInput,
}) => {
  const ref = useRef(null);
  const inputRef = useRef(null);

  const { xScroll, yScroll } = useContext(ScrollContext);

  const [showList, setShowList] = useState(false);
  const [filter, setFilter] = useState(value || "");

  useState(() => {
    if (languageSelection) {
      polyfillCountryFlagEmojis();
    }
  }, []);

  if (useKeyPress("Escape")) {
    if (showList) {
      setShowList(false);
    }
  }

  useEffect(() => {
    setFilter(value);
  }, [value]);

  const handleMouseUp = (e) => {
    if (ref.current) {
      const element = ref.current;
      const rect = element.getBoundingClientRect();
      if (
        e.pageX - xScroll < rect.left ||
        e.pageX - xScroll > rect.left + rect.width ||
        e.pageY - yScroll < rect.top ||
        e.pageY - yScroll > rect.top + rect.height
      ) {
        setShowList(false);
      }
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleMouseUp);

    return () => {
      document.removeEventListener("click", handleMouseUp);
    };
  });

  useEffect(() => {
    if (!filter) {
      onSelection({ type: "", description: "", abbrName: "" });
    }
  }, [filter]);

  const handleChange = (text) => {
    setFilter(text);
    if (text.length > 0) {
      setShowList(true);
    }

    if (!text && onClearInput) {
      onClearInput();
    }
  };

  const handleKeyDown = (e) => {
    console.log("keyDown");
    if (e.code.toUpperCase() === "TAB") {
      // tab key
      if (
        filter &&
        listElements.filter((o) => {
          if (!filter.length) {
            return true;
          } else {
            return display
              ? o[display]?.toUpperCase().startsWith(filter.toUpperCase())
              : o.description.toUpperCase().startsWith(filter.toUpperCase());
          }
        }).length === 1
      ) {
        const li = listElements.filter((o) => {
          if (!filter.length) {
            return true;
          } else {
            return display
              ? o[display]?.toUpperCase().startsWith(filter.toUpperCase())
              : o.description.toUpperCase().startsWith(filter.toUpperCase());
          }
        })[0];
        onSelection(li);

        // original
        // This was causing filter to incorrectly be set to undefined and causing the filter.toUpperCase() call below to cause an error.
        // setFilter(li[display]);

        // Changed by RWD on 9/7/2022.
        // Note that filter is automatically updated once a dropdown selection is made via the useEffect above.  Thus, setting the filter here appears to be redundant.
        setFilter(li.description);

        setShowList(false);
      } else if (
        display &&
        listElements.some(
          (li) => li[display]?.toUpperCase() === filter.toUpperCase()
        )
      ) {
        const li = listElements.find(
          (li) => li[display]?.toUpperCase() === filter.toUpperCase()
        );
        onSelection(li);
        setFilter(li[display]);
        setShowList(false);
      } else if (
        !display &&
        listElements.some(
          (li) => li.description.toUpperCase() === filter.toUpperCase()
        )
      ) {
        const li = listElements.find(
          (li) => li.description.toUpperCase() === filter.toUpperCase()
        );
        onSelection(li);
        setFilter(li.description);
        setShowList(false);
      } else {
        setFilter(value);
      }
      setShowList(false);
    }
  };

  const handleKeyUp = (event) => {
    const code = event.keyCode || event.which;
    if (code === 9) {
      setShowList(false);
    }
  };

  let updatedFilter = isDevices ? getNewDeviceName(filter) : filter;

  return (
    <div
      ref={ref}
      className={
        `${styles.DropDownList__group}  ` +
        `${loginBanner ? styles.loginBanner : ""}`
      }
      onKeyDown={(e) => handleKeyDown(e)}
      onKeyUp={handleKeyUp}
      onClick={(e) => e.stopPropagation()}
    >
      {!loginBanner && <label>{labelName}</label>}
      <div
        className={
          `${styles.DropDownList__input_group} ` +
          `${loginBanner ? styles.loginBanner : ""} ` +
          `${languageSelection ? styles.polyfillFlags : ""}`
        }
      >
        <input
          type={"text"}
          placeholder={placeholder}
          disabled={isEnabled ? !isEnabled : false}
          value={updatedFilter !== "Blank" ? updatedFilter ?? "" : ""}
          //readOnly={true}
          onClick={(e) => {
            e.preventDefault();
          }}
          onChange={(e) => handleChange(e.target.value)}
          style={inputStyle}
          ref={inputRef}
        />
        <button
          className={styles.selectButton}
          onClick={(e) => {
            e.preventDefault();
            if (inputRef?.current && !inputRef?.current.value) {
              inputRef.current.focus();
            }
            setShowList((prevState) => {
              return !prevState;
            });
          }}
        >
          <img
            src={loginBanner ? cheveronDownIconWhite : cheveronDownIcon}
            alt={"dropdown button"}
          />
        </button>
      </div>
      {!loginBanner && <div className={styles.DropDownList__control_border} />}
      {showList && (
        <div
          className={
            `${styles.DropDownList__list} ` +
            `${languageSelection ? styles.polyfillFlags : ""}`
          }
        >
          {listElements.length > 0 &&
            listElements
              .filter((o) => {
                if (!filter || filter === value) {
                  return true;
                } else {
                  return display
                    ? o[display]?.toUpperCase().startsWith(filter.toUpperCase())
                    : o.description
                        .toUpperCase()
                        .startsWith(filter.toUpperCase());
                }
              })
              .map((listElement, index) => {
                let updatedDescription = isDevices
                  ? getNewDeviceName(listElement.description)
                  : listElement.description;
                return (
                  <p
                    key={index}
                    onClick={() => {
                      onSelection(listElement);
                      setFilter(
                        display ? listElement[display] : listElement.description
                      );
                      setShowList(false);
                    }}
                  >
                    {display ? listElement[display] : updatedDescription}
                  </p>
                );
              })}
        </div>
      )}
      {validationText && (
        <label className={styles.DropDownList__validation}>
          {validationText}
        </label>
      )}
    </div>
  );
};

export default DropdownInput;
